import { render, staticRenderFns } from "./ReportDownloadForm.vue?vue&type=template&id=fa64ad86&scoped=true"
import script from "./ReportDownloadForm.vue?vue&type=script&lang=js"
export * from "./ReportDownloadForm.vue?vue&type=script&lang=js"
import style0 from "./ReportDownloadForm.vue?vue&type=style&index=0&id=fa64ad86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa64ad86",
  null
  
)

export default component.exports